import type { InputHTMLAttributes } from "react";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
}

export function Input({ label, error, className = "", id, ...rest }: InputProps) {
  return (
    <div className="flex flex-col gap-1.5">
      {label && (
        <label htmlFor={id} className="text-sm font-medium text-ink-600">
          {label}
        </label>
      )}
      <input
        id={id}
        className={`rounded-xl border bg-white px-3 py-2 text-sm outline-none transition focus:ring-2 focus:ring-brand-500/20 ${
          error ? "border-red-400" : "border-ink-100 focus:border-brand-500"
        } ${className}`}
        {...rest}
      />
      {error && <span className="text-xs text-red-600">{error}</span>}
    </div>
  );
}
